import { render, staticRenderFns } from "./SenseDisplay.vue?vue&type=template&id=b2afd322&"
import script from "./SenseDisplay.vue?vue&type=script&lang=js&"
export * from "./SenseDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports